module.exports = __webpack_public_path__ + "img/idx_header_logo.c153554b.png";